import React, { FC } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { toMoneyText } from '../Money/toMoneyText';
import useMoneyFormatter from '../Money/useMoneyFormatter';
import strikeThrough from '../Money/variants/strikeThrough';
import {
  RawMoneyProps,
  strikeThroughValues,
  StyledContainerProps,
} from './types';

const StyledContainer = styled('span')<StyledContainerProps>(strikeThrough);

const RawMoney: FC<RawMoneyProps> = ({
  children: amount,
  strikeThrough = 'none',
  rounded = false,
  ...props
}) => {
  const formatter = useMoneyFormatter({ ...props, rounded, styled: false });

  const moneyParts = formatter.format(amount);
  const moneyText = toMoneyText(moneyParts);
  return strikeThrough === 'none' ? (
    moneyText
  ) : (
    <StyledContainer strikeThrough={strikeThrough}>{moneyText}</StyledContainer>
  );
};

RawMoney.propTypes = {
  rounded: PropTypes.bool,
  currency: PropTypes.string.isRequired,
  children: PropTypes.number.isRequired,
  strikeThrough: PropTypes.oneOf(strikeThroughValues),
};

export default RawMoney;
